import styled from "styled-components";
import { primaryColor } from "../../config/constants";

export const SearchWrapper = styled.div`
  position: relative;
  width: 280px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 0.9rem;
  outline: none;

  &::placeholder { color: rgba(255,255,255,0.4); }
  &:focus { border-color: ${primaryColor}; }
`;

export const Dropdown = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #014979;
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 8px;
  list-style: none;
  overflow: hidden;
  z-index: 100;
  max-height: 220px;
  overflow-y: auto;
`;

export const DropdownItem = styled.li`
  padding: 10px 14px;
  cursor: pointer;
  color: #fff;
  font-size: 0.88rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover { background: rgba(255,255,255,0.1); }

  span.role {
    font-size: 0.75rem;
    background: rgba(255,255,255,0.1);
    border-radius: 4px;
    padding: 2px 6px;
    color: rgba(255,255,255,0.6);
  }
`;

export const SelectedUser = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 8px;
  color: #fff;
  font-size: 0.9rem;
  width: 280px;

  button {
    margin-left: auto;
    background: none;
    border: none;
    color: rgba(255,255,255,0.5);
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    &:hover { color: #fff; }
  }
`;
